import axios from 'axios';
import config from '../config/config';

// Create a separate axios instance for public endpoints (no auth required)
let apiUrl = 'http://localhost:5001/purchr-ce58e/us-central1/purchr';
if (config.ENV !== 'development') {
  apiUrl = 'https://us-central1-purchr-ce58e.cloudfunctions.net/purchr';
}

const publicAxios = axios.create({
  baseURL: apiUrl,
});

export default class ManageItemService {
  /**
   * Validate token and get item data
   * @param {string} itemId - The item ID from URL params
   * @param {string} token - The token from URL query params
   * @returns {Promise<object>} - Item data if valid
   */
  static async validateAndGetItem(itemId, token) {
    const response = await publicAxios.get(
      `/itemtokens/validate/${itemId}?token=${encodeURIComponent(token)}`
    );
    return response.data;
  }

  /**
   * Update item using token-based auth
   * @param {string} itemId - The item ID to update
   * @param {string} token - The token for authorization
   * @param {object} updateData - Data to update (name, frequency, isActivated)
   * @returns {Promise<object>} - Success response
   */
  static async updateItem(itemId, token, updateData) {
    const response = await publicAxios.put(
      `/itemtokens/update/${itemId}?token=${encodeURIComponent(token)}`,
      updateData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  }

  /**
   * Get alert history for an item using token-based auth
   * @param {string} itemId - The item ID
   * @param {string} token - The token for authorization
   * @returns {Promise<object>} - Alert history data
   */
  static async getAlertHistory(itemId, token) {
    const response = await publicAxios.get(
      `/itemtokens/alerts/${itemId}?token=${encodeURIComponent(token)}`
    );
    return response.data;
  }
}
